import { LocalStorageService } from './local-storage.service';
import { ConfigurationService } from './config.service';
import { Result } from 'src/app/shared/models';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MstPedidoService {

  public filterFormPed: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public listOrders: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(
    private http: HttpClient,
    private config: ConfigurationService,
    private apiService: ApiService
  ) { }

  public get baseUrl(): string {
    let apiUrl: string = (this.config.result.envName === undefined) ? this.config.result.apiUrl + `WA_eCommerce${this.config.result.codCia}/api/Pedido/` : this.config.result.apiUrl + `api/Pedido/`;
    return apiUrl;
  }

  /********************************************* */
  public setFilterFormPed(data: any) {
    this.filterFormPed.next(data);
  }

  public getFilterFormPed() {
    return this.filterFormPed.asObservable();
  }

  public setListOrders(data: any) {
    this.listOrders.next(data);
  }

  public getListOrders() {
    return this.listOrders.asObservable();
  }
  /********************************************* */

  public getOrdersByFilter(pedido: any): Observable<Result> {
    const endpoint = `${this.baseUrl}GetPedidoByFilter`;
    return this.http.post(endpoint, pedido, this.apiService.requestOptions).pipe(map(Result.cast));
  }

  public getOrderByID(pedido: any): Observable<Result> {
    const endpoint = `${this.baseUrl}GetPedidoById/${pedido.cdocu}/${pedido.nro}`;
    return this.http.get(endpoint, this.apiService.requestOptions).pipe(map(Result.cast));
  }

}
